import { DAY_STATUS, DayStatus } from '../times.types';
import { FormGroup } from '@angular/forms';

export function dayStatusOf (group: FormGroup, dayIndex: number): DayStatus {
  const rawDays: unknown = group.get('days')?.value;

  if (!Array.isArray(rawDays)) return DAY_STATUS.neutral;

  const candidate: unknown = rawDays[ dayIndex ];

  if (candidate === DAY_STATUS.neutral || candidate === DAY_STATUS.open || candidate === DAY_STATUS.closed)
    return candidate;

  return DAY_STATUS.neutral;
}
export function isDayTakenElsewhere (
  groups: FormGroup[],
  currentGroupIndex: number,
  dayIndex: number
): boolean {
  return groups.some((group: FormGroup, index: number) =>
    index !== currentGroupIndex && dayStatusOf(group, dayIndex) !== DAY_STATUS.neutral);
}
export function isDayDisabled (
  groups: FormGroup[],
  groupIndex: number,
  dayIndex: number
): boolean {
  if (groupIndex < 0 || groupIndex >= groups.length) return false;

  const group: FormGroup | undefined = groups[ groupIndex ];

  if (!group) return false;


  const statusHere: DayStatus = dayStatusOf(group, dayIndex);

  return statusHere === DAY_STATUS.neutral && isDayTakenElsewhere(groups, groupIndex, dayIndex);
}
export function toggleDayStatus (current: DayStatus): DayStatus {
  switch (current) {
    case DAY_STATUS.neutral: {
      return DAY_STATUS.open;
    }

    /*
     * TODO: kann wieder rein wenn neues backend da ist
     *Case DAY_STATUS.open: {
     *  return DAY_STATUS.closed;
     *}
     */

    default: {
      return DAY_STATUS.neutral;
    }
  }
}
